import React from 'react';

import defaultContext from './defaultContext';

// Make sure the shape of the default value passed to
// createContext matches the shape that the consumers expect!
export const RMWContext = React.createContext(defaultContext);
